<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <div class="list-search">
        <h3 class="mt0 mb20">{{'List farmers plant product'|translate}}: {{productName}}</h3>
        <p>
          <i class="far fa-hand-point-right"></i>
          {{'More information about this product'|translate}}
          <router-link
            :to="{ name: 'ProductDetail', params: { productId: productId,productName:productName  }}"
          >{{'Click here'|translate}}</router-link>
        </p>
        <p>
          {{'Range'|translate}} :
          <span v-if="km == 0">{{'Everywhere'|translate}}</span>
          <span v-if="km > 0">{{km}} KM</span>
        </p>
        <loading v-if="working" :text="'Please wait'|translate"></loading>

        <div class="row mt40" v-if="!working">
          <div class="col-md-12 col-xs-12" v-if="search_result.length== 0">
            <div class="alert alert-info" role="alert">{{'No result'|translate}}</div>
          </div>

          <div class="col-md-6 col-xs-12" v-for="(garden) in search_result" :key="garden.id">
            <div class="media search-item">
              <div class="media-left">
                <router-link :to="{ name: 'ProfileGarden', params: { gardenId: garden.id }}">
                  <img
                    class="media-object"
                    style="width:160px;"
                    v-if="!garden.feature_image_path"
                    src="/static/images/no-photo.jpg"
                  />
                  <img
                    class="media-object"
                    style="width:160px;"
                    v-if="garden.feature_image_path"
                    :src="garden.feature_image_path"
                  />
                </router-link>
              </div>
              <div class="media-body">
                <p>
                  <router-link :to="{ name: 'ProfileGarden', params: { gardenId: garden.id }}">
                    <h4 class="media-heading">{{garden.name}}</h4>
                  </router-link>
                </p>
                <p v-if="garden.province_name">{{garden.province_name}}</p>
                <p class="distance">
                  <i class="fas fa-motorcycle"></i>
                  {{roundNumber(garden.km)}} km
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
export default {
  name: "Search",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      working: true,
      productName: "",
      productId: "",
      lat: null,
      lng: null,
      km: 0,
      search_result: null
    };
  },
  computed: {},
  methods: {
    strippedContent(html) {
      let regex = /(<([^>]+)>)/gi;
      return html.replace(regex, "");
    },
    roundNumber(number) {
      return Math.round(number * 100) / 100;
    }
  },
  mounted() {
    this.productId = this.$route.params.productId;
    this.productName = this.$route.params.productName;

    if (this.$route.params.km) {
      this.km = parseInt(this.$route.params.km);
    }

    this.lat = this.$route.params.lat;
    this.lng = this.$route.params.lng;

    let data = {
      product_id: this.productId,
      lat: this.lat,
      lng: this.lng,
      km: this.km
    };
    Utils.request(this, true)
      .get(`/search/`, { params: data })
      .then(response => {
        this.working = false;
        this.search_result = response.data.data;
      })
      .catch(error => {});
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/SearchGarden.vue